module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="remind-app__modal-header">\n    <div class="remind-app__modal-clock"></div>\n    <span>Before you go...</span>\n    <h3>Set a reminder to finish</h3>\n</div>\n<div class="action-sheet">\n    <button class="action-sheet__non-button-option emphasis" data-reminder="2hr">In 2 hours</button>\n    <button class="action-sheet__non-button-option emphasis" data-reminder="tonight">Tonight</button>\n    <button class="action-sheet__non-button-option emphasis" data-reminder="tomorrow">Tomorrow</button>\n    <a href="/" class="action-sheet__non-button-option">\n        I\'ll remember\n    </a>\n</div>\n';

}
return __p
}